import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';

export const accountLabels = {
  account: {
    common: {
      lbl_order_history_product_unavailable_header: 'Sorry! This item is no longer available.',
      lbl_order_history_product_back_cta: 'GO BACK',
    },
  },
};

export const getAccountLabelsNew = () => {
  return getLabelFromCopyOrFromTranslation('account.common', accountLabels);
};
